module.exports = __webpack_public_path__ + "static/ssat-7dbf957979d8c094548c39fbadbf24b2.jpg";